import { translate as t } from "../../infrastructure/translate/localization";

const literals = (arr) => {
  const translated = {};
  arr.forEach((el) => {
    translated[el] = t(el);
  });
  return translated;
};

const cachedT = literals([
  "spreadsheet-headers.name",
  "spreadsheet-headers.surnames",
  "spreadsheet-headers.surname-first",
  "spreadsheet-headers.surname-second",
  "spreadsheet-headers.email",
  "spreadsheet-headers.nif",
  "spreadsheet-headers.annual-gross-salary",
  "spreadsheet-headers.internal-id",
  "spreadsheet-headers.cost-center",
  "spreadsheet-headers.subsidiary",
  "spreadsheet-headers.optional",
  "spreadsheet-headers.hiring-date",
  "spreadsheet-headers.workTimePercentage",
  "spreadsheet-headers.birth-date",
  "spreadsheet-headers.collective-agreement-salary",
  "spreadsheet-headers.number-of-paychecks",
  "spreadsheet-headers.nationality",
  "spreadsheet-headers.sex",
  "spreadsheet-headers.address-street-name",
  "spreadsheet-headers.address-street-number",
  "spreadsheet-headers.address-block",
  "spreadsheet-headers.address-door",
  "spreadsheet-headers.address-floor",
  "spreadsheet-headers.address-details",
  "spreadsheet-headers.address-postal-code",
  "spreadsheet-headers.address-locality",
  "spreadsheet-headers.address-province",
  "spreadsheet-headers.address-district",
  "spreadsheet-headers.mobile-country-code",
  "spreadsheet-headers.mobile-phone-number",
  "spreadsheet-headers.bank-account",
]);

export const validateExcelFormat = (type, item) => {
  switch (type) {
    case "massiveUpload":
      return (
        cachedT["spreadsheet-headers.name"] in item &&
        cachedT["spreadsheet-headers.surname-first"] in item &&
        cachedT["spreadsheet-headers.email"] in item &&
        cachedT["spreadsheet-headers.nif"] in item &&
        cachedT["spreadsheet-headers.annual-gross-salary"] in item
      );
    case "massiveEdit":
      return (
        cachedT["spreadsheet-headers.name"] in item &&
        cachedT["spreadsheet-headers.surnames"] in item &&
        cachedT["spreadsheet-headers.email"] in item &&
        cachedT["spreadsheet-headers.nif"] in item &&
        cachedT["spreadsheet-headers.annual-gross-salary"] in item
      );
    default:
      return false;
  }
};

export const formatDataFromExcel = (type, item) => {
  switch (type) {
    case "massiveUpload":
      return {
        name: item[cachedT["spreadsheet-headers.name"]],
        firstSurname: item[cachedT["spreadsheet-headers.surname-first"]],
        secondSurname:
          item[cachedT["spreadsheet-headers.surname-second"]] || "",
        surname: `${item[cachedT["spreadsheet-headers.surname-first"]]} ${
          item[cachedT["spreadsheet-headers.surname-second"]] || ""
        }`,
        email: item[cachedT["spreadsheet-headers.email"]],
        legalId: item[cachedT["spreadsheet-headers.nif"]],
        grossSalary: item[cachedT["spreadsheet-headers.annual-gross-salary"]],
        internalId:
          item[
            `${cachedT["spreadsheet-headers.internal-id"]} ${cachedT["spreadsheet-headers.optional"]}`
          ] || null,
        costCenter:
          item[
            `${cachedT["spreadsheet-headers.cost-center"]} ${cachedT["spreadsheet-headers.optional"]}`
          ] || null,
        payrollCompany:
          item[
            `${cachedT["spreadsheet-headers.subsidiary"]} ${cachedT["spreadsheet-headers.optional"]}`
          ] || null,
        hiringDate: item[cachedT["spreadsheet-headers.hiring-date"]] || null,
      };
    case "massiveEdit":
      return {
        name: item[cachedT["spreadsheet-headers.name"]],
        surname: item[cachedT["spreadsheet-headers.surnames"]],
        email: item[cachedT["spreadsheet-headers.email"]],
        legalId: item[cachedT["spreadsheet-headers.nif"]],
        birthDate: item[cachedT["spreadsheet-headers.birth-date"]] || null,
        grossSalary:
          item[cachedT["spreadsheet-headers.annual-gross-salary"]] ===
          t("upload-employees-section.hidden")
            ? "REDACTED"
            : item[cachedT["spreadsheet-headers.annual-gross-salary"]],
        workTimePercentage:
          item[cachedT["spreadsheet-headers.workTimePercentage"]],
        collectiveAgreementSalary:
          item[cachedT["spreadsheet-headers.collective-agreement-salary"]] ||
          null,
        numberOfPaychecks:
          item[cachedT["spreadsheet-headers.number-of-paychecks"]] || null,
        internalId: item[cachedT["spreadsheet-headers.internal-id"]] || null,
        costCenter: item[cachedT["spreadsheet-headers.cost-center"]] || null,
        payrollCompany: item[cachedT["spreadsheet-headers.subsidiary"]] || null,
        hiringDate: item[cachedT["spreadsheet-headers.hiring-date"]] || null,
        nationality: item[cachedT["spreadsheet-headers.nationality"]] || null,
        sex: item[cachedT["spreadsheet-headers.sex"]] || null,
        streetName:
          item[cachedT["spreadsheet-headers.address-street-name"]] || null,
        streetNumber:
          item[cachedT["spreadsheet-headers.address-street-number"]] || null,
        block: item[cachedT["spreadsheet-headers.address-block"]] || null,
        door: item[cachedT["spreadsheet-headers.address-door"]] || null,
        floor: item[cachedT["spreadsheet-headers.address-floor"]] || null,
        details: item[cachedT["spreadsheet-headers.address-details"]] || null,
        postalCode:
          item[cachedT["spreadsheet-headers.address-postal-code"]] || null,
        locality: item[cachedT["spreadsheet-headers.address-locality"]] || null,
        province: item[cachedT["spreadsheet-headers.address-province"]] || null,
        district: item[cachedT["spreadsheet-headers.address-district"]] || null,
        mobileCountryCode:
          item[cachedT["spreadsheet-headers.mobile-country-code"]] || null,
        mobilePhone:
          item[cachedT["spreadsheet-headers.mobile-phone-number"]] || null,
        bankAccount: item[cachedT["spreadsheet-headers.bank-account"]] || null,
      };
    default:
      return item;
  }
};
